import { useState } from "react";
import styles from "./RegisterForm.module.scss";
import classNames from "classnames/bind";
import { IRegisterPayload } from "~/utils/interface/auth";
import PrimaryInput from "~/components/common/primary-input/PrimaryInput";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import OutlinedButton from "~/components/common/outlined-button/OutlinedButton";
import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
const cx = classNames.bind(styles);

const RegisterForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<IRegisterPayload>({});

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBackToLogin = () => {
    navigate("/admin/login");
  };

  return (
    <div className={cx("register-form-container")}>
      <OutlinedButton
        title="Back to login"
        icon={<ArrowLeftIcon className={cx("back-to-login-icon")} />}
        onClick={handleBackToLogin}
        className={cx("back-to-login-button")}
      />
      <div className={cx("register-form-content")}>
        <div className={cx("register-label")}>
          <h3 className={cx("title")}>Register</h3>
          <p className={cx("description")}>
            Welcome! Please enter your details.
          </p>
        </div>

        <div className={cx("register-form")}></div>

        <div className={cx("register-form-actions")}>
          <PrimaryButton
            title="Sign up"
            onClick={() => {}}
            className={cx("register-button")}
          />
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
